export class Holiday {
  id?: string;
  name: string;
  date: string;

  constructor(flow) {
    if (flow.id) { this.id = flow.id; }
    this.name = flow.name;
    this.date = flow.date;
  }
}
